/* components/ui/Switch.jsx — переключатель (тумблер) UI-kit.
   Кнопка role="switch" на классе .switch (styles/settings.css). Управляемый:
   checked + onChange(next). Употребление: NotificationsTab (email/в шапке),
   RoleEditorModal (вкладки матрицы доступов). Витрина — /dev/uikit. */

import React from 'react';

function Switch({ checked, onChange, disabled, ariaLabel }) {
  return (
    <button type="button" role="switch" aria-checked={checked} aria-label={ariaLabel} disabled={disabled}
      className={'switch' + (checked ? ' is-on' : '') + (disabled ? ' is-disabled' : '')}
      onClick={() => !disabled && onChange(!checked)}>
      <span className="switch__thumb" />
    </button>
  );
}

export { Switch };
